module.exports = __webpack_public_path__ + "static/media/vector-t-shirt-designs-cover.53724d30.png";